<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="`Restore ${title}`"
        />
      </header>
      <div class="flex justify-center items-baseline mt-4">
        <p v-text="'Are you sure you want to restore this communication?'" />
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn-blue"
        @click="restore"
        v-text="'Restore'"
      />
      <a
        class="mx-6"
        href="#"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'RestoreArchivedCommunicationModal',
  data() {
    return {
      error: '',
    }
  },
  computed: {
    communication() {
      return this.$store.state.communication.restoreArchivedCommunicationModal.communication
    },
    title() {
      if (!this.communication) {
        return ''
      }

      switch (this.communication.attributes._type) {
        case 'SMS':
          return 'SMS'
        case 'Email':
          return 'Email'
        default:
          return 'communication'
      }
    },
    uuid() {
      return this.communication ? this.communication.uuid : ''
    },
    show() {
      return this.$store.state.communication.restoreArchivedCommunicationModal.open
    },
  },
  methods: {
    restore() {
      if (!this.communication) {
        return
      }

      let restoreType

      switch (this.communication.attributes._type.toLowerCase()) {
        case 'email':
          restoreType = 'emails'
          break
        case 'sms':
          restoreType = 'sms'
          break
        case 'blogentry':
          restoreType = 'blog'
          break
        default:
          throw 'Could not determine communication type.'
      }

      this.$api.active().patch(`communications/${restoreType}/${this.uuid}/restore`)
        .then(() => {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Communication restored as a draft!',
          })

          this.$emit('restored')

          this.close()
        }).catch((error) => {
          this.error = error.response.data.message

          this.$store.commit('baseAddNotification', {
            type: 'error',
            title: 'Error',
            text: error.response.data.message,
          })
        })
    },
    close() {
      this.error = ''

      this.$store.commit('communicationCloseRestoreArchivedCommunicationModal')
    },
  },
}
</script>
